"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var EventHandler_1 = __importDefault(require("./EventHandler"));
var ChatBase = /** @class */ (function (_super) {
    __extends(ChatBase, _super);
    function ChatBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._eventsMapped = false;
        _this._loaded = false;
        return _this;
    }
    /**
     * Method to init chat loading process, must be executed in Driver class. Can be overridden only in a last
     * resort, but its really not recommended.
     * @returns {Promise<void>}
     */
    ChatBase.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _super.prototype.init.call(this);
                        this.on('load', function () { return _this.ready(); });
                        this.mapApiEvents();
                        _a = this;
                        return [4 /*yield*/, this._loader()];
                    case 1:
                        _a._api = _b.sent();
                        this.mapApiEvents();
                        this.ready();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Inform class that its loaded and ready to work.
     */
    ChatBase.prototype.ready = function () {
        this._loaded = true;
    };
    Object.defineProperty(ChatBase.prototype, "loaded", {
        /**
         * Quick check that returns true if chat is loaded.
         * @returns {boolean}
         */
        get: function () {
            return this._loaded;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a Promise that resolves on chat load, if already loaded, returns a resolved promise
     * @returns {Promise<void>}
     */
    ChatBase.prototype.toLoad = function () {
        var _this = this;
        if (this._loaded)
            return Promise.resolve();
        return new Promise(function (resolve) { return _this.on('load', function () { return resolve(); }); });
    };
    /**
     * Turn ChatBase into a thenable, use like a regular promise. Resolves on chat load.
     * @param resolve
     * @param reject
     * @returns {Promise<void>}
     */
    ChatBase.prototype.then = function (resolve, reject) {
        var _this = this;
        var valueFromCallback;
        if (this._loaded) {
            try {
                valueFromCallback = resolve ? resolve(this) : undefined;
            }
            catch (e) {
                return Promise.reject(reject ? reject(e) : e);
            }
            return Promise.resolve(valueFromCallback);
        }
        return new Promise(function (res, rej) {
            _this.on('load', function () {
                try {
                    valueFromCallback = resolve ? resolve(_this) : undefined;
                }
                catch (e) {
                    return rej(reject ? reject(e) : e);
                }
                res(valueFromCallback);
            });
        });
    };
    /**
     * Helper to build drivers that needs to monitor some global event or value.
     *
     * Keep testing function given in "test" argument until it returns a truthy value. After that, resolves a
     * promise with value returned in function given in "then" argument. If "then" callback generates an error,
     * Promise is rejected with same exception.
     *
     * @param {() => any} test
     * @param {() => any} then
     * @param {number} testInterval
     * @param {number} limit
     * @returns {Promise<any>}
     */
    ChatBase.prototype.waitFor = function (test, then, testInterval, limit) {
        if (testInterval === void 0) { testInterval = 200; }
        if (limit === void 0) { limit = 10000; }
        try {
            if (test())
                return Promise.resolve(then());
        }
        catch (e) {
            return Promise.reject(e);
        }
        return new Promise(function (resolve, reject) {
            var interval;
            var count = 0;
            try {
                interval = setInterval(function () {
                    if (count > limit) {
                        clearInterval(interval);
                        reject("Wait time passed the allowed limit " + limit);
                    }
                    if (test()) {
                        clearInterval(interval);
                        var resolvedValue = void 0;
                        try {
                            resolvedValue = then();
                            resolve(resolvedValue);
                        }
                        catch (e) {
                            reject(e);
                        }
                    }
                    count += testInterval;
                }, testInterval);
            }
            catch (e) {
                reject('Error setting interval');
            }
        });
    };
    /**
     * Set events from _eventsMapped to Chat's global JS API.
     */
    ChatBase.prototype.mapApiEvents = function () {
        var _this = this;
        if (this._eventsMapped || !this._api)
            return;
        var _loop_1 = function (prop) {
            var event_1 = this_1._events[prop];
            if (!event_1)
                return "continue";
            try {
                this_1.attachEvent(event_1.callbackName, function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this.trigger.apply(_this, [prop].concat(args));
                });
            }
            catch (e) {
                throw ChatBase.setError('Error setting callbacks in Chat API', e);
            }
        };
        var this_1 = this;
        for (var _i = 0, _a = Object.keys(this._events); _i < _a.length; _i++) {
            var prop = _a[_i];
            _loop_1(prop);
        }
        this._eventsMapped = true;
    };
    /**
     * Method to attach each event to Chat's global JS API. Can be overridden in Driver class to change its behavior.
     * Default simply stores callback method is a global key, most chats JS APIs works that way.
     * @param {string} event
     * @param {EventCallback<any>} callback
     */
    ChatBase.prototype.attachEvent = function (event, callback) {
        // @ts-ignore
        this._api[event] = callback;
    };
    return ChatBase;
}(EventHandler_1.default));
exports.default = ChatBase;
//# sourceMappingURL=ChatBase.js.map